import React from 'react';
import { siteConfig } from '../config/siteConfig';
import ScrollingTitle from '../components/ScrollingTitle/ScrollingTitle';
import './Page.css';

const Partners = () => {
  const { partners } = siteConfig;

  return (
    <>
    <div className="partners-page">
      <ScrollingTitle lines={partners.title.lines} />
      
      <div className="partners-content">
        <div className="partners-container">
          
          {/* Members Section */}
          <div className="partners-section">
            <h2 className="partners-section-title">{partners.membersSection.title}</h2>
            <div className="partners-logos-grid">
              {partners.membersSection.logos.map((logo, index) => (
                <div key={index} className="partner-logo-item">
                  <img src={logo.src} alt={logo.alt} />
                </div>
              ))}
            </div>
          </div>
          
          {/* Media Partners Section */}
          <div className="partners-section">
            <h2 className="partners-section-title">{partners.mediaPartnersSection.title}</h2>
            <div className="partners-logos-grid">
              {partners.mediaPartnersSection.logos.map((logo, index) => (
                <div key={index} className="partner-logo-item">
                  <img src={logo.src} alt={logo.alt} />
                </div>
              ))}
            </div>
          </div>
          
        </div>
      </div>
      <div className="partners-section-spacer" />
    </div>
     </>
  );
};

export default Partners; 